import Legend from "./Legend/index.js";
import labelTransformFactory from "../util/labelTransformFactory.js";
import defaultDomain from "../util/defaultDomain.js";
import identity from "../util/identity.js"; // eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A Size legend component that creates a legend with discrete size intervals.
 * Useful for visualizing continuous numeric data with size-based scales.
 */
export default function Size(_ref) {
  let {
    scale,
    domain: inputDomain,
    steps = 5,
    labelFormat = identity,
    labelTransform = labelTransformFactory,
    ...restProps
  } = _ref;
  const domain = inputDomain || defaultDomain({
    steps,
    scale
  });
  return /*#__PURE__*/_jsx(Legend, {
    scale: scale,
    domain: domain,
    labelFormat: labelFormat,
    labelTransform: labelTransform,
    ...restProps
  });
}